import { render } from "./illuminationControllerDali.vue?vue&type=template&id=a9847004&scoped=true"
import script from "./illuminationControllerDali.vue?vue&type=script&lang=js"
export * from "./illuminationControllerDali.vue?vue&type=script&lang=js"

import "./illuminationControllerDali.vue?vue&type=style&index=0&id=a9847004&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9847004"]])

export default __exports__